/**
 * ViewStore - MobX store for managing dashboard view state
 *
 * This store:
 * - Manages the current view selection (Organization, Group, Individual)
 * - Determines which options are enabled based on available data
 */

import { makeAutoObservable } from "mobx"
import { logger } from "../lib/logger"

export type ViewType = "organization" | "group" | "individual"

export class ViewStore {
  currentView: ViewType = "organization"

  constructor() {
    makeAutoObservable(this)
  }

  /**
   * Set the current view
   */
  setView(view: ViewType): void {
    logger.info(`Changing view to: ${view}`, { component: "ViewStore" })
    logger.track("view_changed", { view })
    this.currentView = view
  }

  /**
   * Check if the current view is organization
   */
  get isOrganizationView(): boolean {
    return this.currentView === "organization"
  }

  /**
   * Check if the current view is group
   */
  get isGroupView(): boolean {
    return this.currentView === "group"
  }

  /**
   * Check if the current view is individual
   */
  get isIndividualView(): boolean {
    return this.currentView === "individual"
  }

  /**
   * Reset to default view
   */
  reset(): void {
    this.currentView = "organization"
    logger.info("ViewStore reset", { component: "ViewStore" })
  }
}
